import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "items-left" }


export default /*#__PURE__*/_defineComponent({
  __name: 'TimelineScorecard',
  props: {
    header: {},
    subheader: {},
    disable: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_component_q_btn, {
    "no-caps": "",
    outline: "",
    color: "primary",
    class: "full-width q-py-sm",
    style: {"min-height":"86px"},
    disable: _ctx.disable
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_q_item_label, { overline: "" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.header), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_q_item_label, { class: "text-h6 text-weight-medium" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.subheader), 1)
          ]),
          _: 1
        }),
        _renderSlot(_ctx.$slots, "content")
      ])
    ]),
    _: 3
  }, 8, ["disable"]))
}
}

})